import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { allAgencyPages } from "../data/agencyPages";
import { seoPages, SITE } from "../data/seoPages";
import { kbArticles } from "../data/knowledgeBase";

const MAIN = [
  ["/", "Home"], ["/services", "Services"], ["/software", "AI Software"], ["/knowledge", "Knowledge Base"],
  ["/growth-story", "Growth Story"], ["/certificates", "Certificates"], ["/about", "About"], ["/blog", "Blog"],
  ["/faq", "FAQ"], ["/our-clients", "Our Clients"], ["/service-locations", "Service Locations"],
  ["/case-studies", "Case Studies"], ["/search", "Search"], ["/reports/marketplace-onboarding-report-2026", "Marketplace Onboarding Report 2026"],
  ["/best-onboarding-agency-india", "Best Onboarding Agency India"], ["/refund-policy", "Refund Policy"],
];

export default function HtmlSitemapPage() {
  return (
    <div className="min-h-screen bg-white pt-24 pb-16" data-testid="html-sitemap-page">
      <Helmet>
        <title>Sitemap | BrandBorn — All Pages</title>
        <meta name="description" content="Complete HTML sitemap of BrandBorn: services, agency pages, AI software, knowledge base and blog." />
        <link rel="canonical" href={`${SITE}/sitemap-page`} />
      </Helmet>
      <div className="max-w-5xl mx-auto px-4">
        <h1 className="text-3xl md:text-4xl font-black text-gray-900 mb-10">BrandBorn Sitemap</h1>

        {[
          ["Main Pages", MAIN.map(([p, n]) => ({ p, n }))],
          ["Onboarding Agency Services", allAgencyPages.map((a) => ({ p: `/${a.slug}`, n: a.kw }))],
          ["AI Software & Tools", seoPages.map((s) => ({ p: `/software/${s.slug}`, n: s.kw }))],
          ["Knowledge Base", kbArticles.map((k) => ({ p: `/knowledge/${k.slug}`, n: k.q }))],
        ].map(([title, links]) => (
          <section key={title} className="mb-10">
            <h2 className="text-xl font-black text-gray-900 mb-4 border-b border-gray-100 pb-2">{title}</h2>
            <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
              {links.map((l) => (
                <li key={l.p}><Link to={l.p} className="text-sm text-blue-600 hover:underline">{l.n}</Link></li>
              ))}
            </ul>
          </section>
        ))}
        <p className="text-sm text-gray-400">Blog articles are listed on the <Link to="/blog" className="text-blue-600 hover:underline">Blog page</Link>.</p>
      </div>
    </div>
  );
}
